<div class="role-dialog">
    <button type="button" class="close-button" aria-label="Dialog schließen" (click)="close()" [disabled]="isSaving()">
        ×
    </button>

    <header class="dialog-header">
        <h2>{{ dialogTitle }}</h2>
        <p>Definiere Name und Modulzugriffe der Rolle.</p>
    </header>

    <form [formGroup]="form" (ngSubmit)="save()">
        <div class="form-field">
            <label for="role-name">Rollenname</label>

            <input id="role-name" type="text" formControlName="name" placeholder="z. B. Filialleiter"
                autocomplete="off" />
            @if (form.controls.name.hasError('required') && form.controls.name.touched) {
            <p class="field-error">Rollenname ist erforderlich</p>
            }
        </div>

        <div class="admin-box">
            <div class="admin-info">
                <mat-icon fontSet="material-icons-outlined">shield</mat-icon>

                <div>
                    <strong>Administratorrolle</strong>
                    <span>Benutzerverwaltung, Rollenzuweisung</span>
                </div>
            </div>

            <mat-slide-toggle formControlName="istAdminRolle" [disabled]="isSaving()" />
        </div>

        <section class="module-section">
            <h3>Modulfreigabe</h3>

            <div class="module-grid">
                @for (module of moduleOptions; track module.value) {
                <button type="button" class="module-option" [class.selected]="isModuleSelected(module.value)"
                    [disabled]="form.controls.istAdminRolle.value || isSaving()" (click)="toggleModule(module.value)">
                    <span class="checkbox-box">
                        @if (isModuleSelected(module.value)) {
                        <mat-icon fontSet="material-icons-outlined">check</mat-icon>
                        }
                    </span>
                    {{ module.label }}
                </button>
                }
            </div>
        </section>

        <footer class="dialog-actions">
            <button type="button" class="cancel-button" (click)="close()" [disabled]="isSaving()">
                Abbrechen
            </button>

            <button type="submit" class="save-button" [disabled]="isSaving()">
                {{ isSaving() ? 'Speichern...' : 'Speichern' }}
            </button>
        </footer>
    </form>
</div>